import axios from 'axios';
import { MasterDataURL } from '../../../../config/UrlEndPoint';

export const URL = `${MasterDataURL}project`;

export function getProjectAll() {
    return axios.get(URL);
}

// items => filtered/sorted result
export function findProjects(queryParams) {
    return axios.post(`${URL}/find`, queryParams);
}

//Get By ID
export function getProjectById(projectId) {
    return axios.get(`${URL}/${projectId}`);
}

// POST => POST: Create the data on the server
export function createProject(project) {
    return axios.post(URL, project);
}

// POST => POST: Add Relation Type on Project
export function addProjectType(projectType) {
    return axios.post(`${URL}/typeproject`, projectType);
}

// UPDATE => PUT: update the branch on the server
export function updateProject(project) {
    return axios.put(`${URL}/${project.uuid}`, project);
}

// DELETE => DELETE: Remove Relation Type on Project
export function removeProjectType(projectType) {
    return axios.delete(`${URL}/typeproject`, { data: projectType });
}


